import React, { useState, useEffect, useRef } from 'react';
import { THEME_CONFIG } from '../constants';
import { Sun, Moon } from 'lucide-react';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const isDark = document.documentElement.classList.contains('dark');
    setIsDarkMode(isDark);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsMoreDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleTheme = () => {
    if (isDarkMode) {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    } else {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }
    setIsDarkMode(!isDarkMode);
  };

  const navLinks = [
    { name: 'Inicio', href: '/' },
    { name: 'Sobre Nosotros', href: '/about' },
    { name: 'Servicios', href: '/services' },
    { name: 'Contacto', href: '/contact' },


  ];
  
/*   const moreLinks = [
    { name: 'Blog', href: '/blog' },
    { name: 'FAQ', href: '/faq' },
    { name: 'Especialistas', href: '/specialists' },

  ];
 */
/*   const allLinks = [...navLinks, ...moreLinks]; */

  return (
    <header className="sticky top-0 z-50 bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg shadow-md">
      <div className="bg-gray-100 dark:bg-gray-800 text-sm text-gray-600 dark:text-gray-300">
        <div className="container mx-auto px-6 py-2 flex justify-between items-center">
          <div className="flex gap-4 md:gap-6">
            <span>📞 (123) 456-7890</span>
            <span>✉️ contacto@saludintegral.com</span>
          </div>
          <span className="hidden md:block">Horario: Lunes a Viernes de 9:00 a 18:00</span>
        </div>
      </div>
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="text-2xl font-bold text-primary">
            {THEME_CONFIG.clinicName}
          </a>
          <div className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href} className="text-gray-700 dark:text-gray-200 hover:text-primary dark:hover:text-primary transition-colors duration-300">
                {link.name}
              </a>
            ))}
             <div className="relative" ref={dropdownRef}>
              {/* <button 
                type="button"
                onClick={() => setIsMoreDropdownOpen(!isMoreDropdownOpen)} 
                name="Más"
                id="Más"
                aria-label="Más"
                className="flex items-center text-gray-700 dark:text-gray-200 hover:text-primary dark:hover:text-primary transition-colors duration-300">
                Más
                <svg className={`w-4 h-4 ml-1 transition-transform ${isMoreDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
              </button> */}
              {/* {isMoreDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-20">
                  {moreLinks.map((link) => (
                    <a key={link.name} href={link.href} onClick={() => setIsMoreDropdownOpen(false)} className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">
                      {link.name}
                    </a>
                  ))}
                </div>
              )} */}
            </div>
          </div>
          <div className="flex items-center space-x-4">
             <button
                type="button"
                name="Toggle dark mode"
                id="Toggle dark mode"
                onClick={toggleTheme}
                className="p-2 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                aria-label="Toggle dark mode"
              >
                {isDarkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </button>
            <a href="/booking" className="hidden md:block bg-primary text-white px-5 py-2 rounded-xl font-semibold hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105">
              Agenda tu Cita
            </a>
            <div className="md:hidden">
              <button 
                type="button"
                name="Toggle menu"
                id="Toggle menu"
                onClick={() => setIsOpen(!isOpen)} 
                className="text-gray-700 dark:text-gray-200 focus:outline-none">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        {isOpen && (
          <div className="md:hidden mt-4">
            {/* {allLinks.map((link) => (
              <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block py-2 px-4 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 rounded">
                {link.name}
              </a>
            ))} */}
            <a href="/booking" onClick={() => setIsOpen(false)} className="block mt-2 w-full text-center bg-primary text-white px-5 py-2 rounded-xl font-semibold hover:bg-opacity-90 transition-all duration-300">
              Agenda tu Cita
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;